<template>
  <div style="height:100%">
    <div id="appmain" v-if="ready_to_run">
      <TopMenuView
        :show_documentation="selection_documents.length > 0"
        @toggle-documentation="globalSettings.toggle_side_panel('nodeDocsWindowOpen')"
        @toggle-news="globalSettings.toggle_side_panel('newsWindowOpen')"
        @toggle-manuals="globalSettings.toggle_side_panel('manualsWindowOpen')"
      />
      <NewsWindow v-if="news_panel_open" @close="globalSettings.newsWindowOpen = false" />
      <DocumentsWindow
        v-if="manuals_panel_open"
        :title="$txt.user_manual"
        :groups="manual_groups"
        @close="globalSettings.manualsWindowOpen = false"
      >
        <!-- The panel carries the Camur manuals only; older systems such as Camur II and
             CM-3 are still documented on the support site.
             TODO: "More on" is hardcoded, pending a translation key. -->
        <template #tree-footer>
          <a
            href="https://www.protector.no/en/support/support.html"
            target="_blank"
          >
            More on protector-technology.com
          </a>
        </template>
      </DocumentsWindow>
      
      <DocumentsWindow
        v-if="node_docs_panel_open"
        :title="$txt.documentation"
        :groups="selection_documents"
        @close="globalSettings.nodeDocsWindowOpen = false"
      />
      <router-view id="main"></router-view>
      <FooterView />
    </div>
    <div v-else>
      <div v-if="load_timeout" style="padding: 20px">
        <h3>Loading failed</h3>
        <table>
          <tbody>
            <tr>
              <td class="fail">timeout:</td>
              <td class="fail">{{ load_timeout }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <LoadingPanel v-else text="Loading..." />
    </div>
  </div>
</template>

<script>
import TopMenuView from "@/components/TopMenuView";
import FooterView from "@/components/FooterView";
import {DataStore} from './datastore';
import NewsWindow from "@/components/NewsWindow";
import DocumentsWindow from "@/components/DocumentsWindow";
import globalSettings from "@/globalsettings.js";
import { MANUAL_GROUPS } from "@/utils/manuals.js";
import { node_document_groups, controller_document_groups } from "@/utils/nodedocs.js";

export default {
  name: "App",
  components: {
    TopMenuView,
    FooterView,
    NewsWindow,
    DocumentsWindow
  },

  data() {
    return {
      load_timeout: false,
      ready_to_run: false,
      oldRoutePath: "",
      globalSettings,
      manual_groups: MANUAL_GROUPS,
    };
  },

  created: function() {
    this.timeout = setInterval(() => this.on_timeout(), 20000);
    setInterval(() => this.check_ready(), 500);
  },

  computed: {
    session_data_loaded() {
      return this.ready_to_run;
    },
    news_panel_open() {
      if (this.$app.session.current_user && globalSettings?.newsWindowOpen) {
        return true;
      } else {
        return false;
      }

    },
    manuals_panel_open() {
      return Boolean(this.$app.session.current_user && globalSettings?.manualsWindowOpen);
    },

    selection_documents() {
      const route = this.$route.name || "";

      if (route.startsWith("node")) {
        const node = this.$app.sltd.node;
        return node == null
          ? []
          : node_document_groups(node.capability, this.$appm.get_node_type_name(node.capability));
      }

      if (route.startsWith("controller"))
        return controller_document_groups(this.$txt.cntrl);

      return [];
    },

    node_docs_panel_open() {
      return Boolean(
        this.$app.session.current_user
        && globalSettings?.nodeDocsWindowOpen
        && this.selection_documents.length > 0
      );
    }
  },

  methods: {
    close_documents_outside_hardware() {
      const route = this.$route.name || "";
      if (!route.startsWith("node") && !route.startsWith("controller"))
        globalSettings.nodeDocsWindowOpen = false;
    },

    on_timeout() {
      this.load_timeout = true;
    },
    check_ready() {
      this.ready_to_run = DataStore.session.loaded;
    },
    set_route() {
      if (this.$route.path != this.oldRoutePath) {
        this.oldRoutePath = this.$route.path;
        this.$appm.set_route(this.$route);
      }
    }
  },
  watch: {
      $route: function() {
        this.set_route();
        this.close_documents_outside_hardware();
    }
  }
};
</script>

<style>
@import "styles/plugins/css/bootstrap.min.css";
@import "styles/plugins/fonts/font-roboto.css";
@import "styles/plugins/fonts/Relevant/font-relevant.css";
</style>

<style lang="less">
@import "styles/main.less";

td.fail {
  padding: 5px;
}
</style>
